import questionManagementImg from "./assets/test-exam-svgrepo-com.svg";
import examCentre from "./assets/school-svgrepo-com.svg";
import slot_exam from "./assets/slot_exam.svg";
import viewExams from "./assets/exams.svg";
import ExamManangement from "./assets/test-exam-svgrepo-com.svg";
import managetest from "./assets/manage-test.svg";
import resulttest from "./assets/resulttest.svg";
import mastermenumain from "./assets/data-center-asset-overview-svgrepo-com.svg";
import subjectmenu from "./assets/translator-subject-svgrepo-com.svg";
import marksmenu from "./assets/sports-badge-recognition-svgrepo-com (1).svg";
import complexity from "./assets/dashboard-svgrepo-com.svg";
import genResult from "./assets/generate.svg";
import viewRes from "./assets/file-document-svgrepo-com.svg";
import reviewRes from "./assets/review-screen-svgrepo-com.svg";
import examinee from "./assets/examinee.svg";
import examSession from "./assets/examSession2.jpg";
import pendingRequest from "./assets/pending-approval-1.png";
import { DataType } from "ka-table";
import CustomerManage from "./assets/business-relationship-icon.svg";

//export const baseServiceUrl = "http://127.0.0.1:8000/api/";
// export const baseServiceUrl = "http://15.206.132.5:8000/api/";
// export const baseServiceUrl = "http://192.168.0.239:8000/api/"; // LOCAL URL

//export const baseServiceUrl = "http://65.0.212.108:8065/api/"; ///////////////////// DEV URL
// export const baseServiceUrl = "http://65.0.212.108:8068/api/";  ////////////    Stage URL
//export const baseServiceUrl = "http://localhost:8010/qcbt/api/";  // dev
//export const baseServiceUrl = "http://65.0.212.108:8068/api/"; ////////////    Stage URL
//export const baseServiceOfflineUrl ="http://15.206.132.5:8000/api/";
// export const baseServiceUrl = "http://15.206.132.5:8000/api/";
// export const baseServiceOfflineUrl = "http://15.206.132.5:8000/api/"; //offline case
//  export const baseServiceUrl = "http://192.168.0.123:8000/api/";
// export const baseServiceUrl = "http://192.168.0.156:8000/api/"  /////////////  Chaku's Server";
// export const baseServiceUrl = "http://cbt.msq.ycsas.in/api/"
//export const baseServiceUrl = "http://192.168.0.249:8000/api/"; /////////////  thakur Server";
//export const baseServiceUrl = "http://cbt.msq.ycsas.in/api/"; /////////////  Chaku's Server";
//export const baseServiceUrl = "http:///api/"; /////////////  Test Centre Server";
// export const baseServiceUrl = `http://localhost:8060/api/`;
 //export const baseServiceUrl = "http://backend.local/api/";
//export const baseServiceUrl = "https://cbt.msqube.com/api/"; ///////////////////// prod URL
 //export const baseServiceUrl = "http://10.70.0.1/api/";  ///////////////////// prod URL
//export const baseServiceUrl = `${window.location.protocol}//${window.location.host}/api/`;
 export const baseServiceUrl = "https://qcbt.in/api/"; ///////////////////// prod URL
// export const baseServiceUrl = "http://dev.msqube.com/qcbt/api/"; ///////////////////// dev URL
export const urls = {
  adminLoginUrl: "users/login",
  getSubjectUrl: "common/domain/subject",
  getMarksDomainUrl: "common/domain/marks",
  getComplexityDomainUrl: "common/domain/complexity",
  getLanguageDomainUrl: "common/domain/language",
  getQuestionUrl: "admin/question/",
  createQuestionUrl: "admin/question/create",
  createExamUrl: "admin/exam/create",
  getAllExamUrl: "admin/exams",
  getExamByIdUrl: "admin/exams/",
  examStartUrl: "examinee/session/start",
  nextQuestionUrl: "examinee/session/nextQuestion",
  EndExamUrl: "examinee/session/submitExam",
  Examresult: "admin/examresult",
  SessionExamresult: "examinee/session/result",
  syncDownload: `common/sync/download`,
  uploadResultForOffline: `common/sync/uploadresults`,
  examSlotList: `/center/examslot`,
  assignQuestion: `admin/qsn_bank/create`,
  uniqueQuestionBankURL: `admin/qsnbank`,
  uploadQuestion: `admin/question/upload`,
  createExam: `admin/exam/create`,
  examSetCreate: `admin/set/create`,
  viewExam: `/admin/exams`,
  editExam: `/admin/exam/edit`,
  examineeResult: `examinee/session/result`,
  examSlotCreate: `center/create/examslot`,
  centerMappingUpload: `center/candidate/mapping/upload`,
  centerUserList: `admin/centeruserlist`,
  SpecificCenterUsers: `admin/examcenter/userlist`,
  generateResult: `admin/result/generate/`,
  statusChange: `admin/exam/edit`,
  setMapping: `center/candidate/set/mapping`,
  overallResultDownload: `report/exam/excel`,
  individualResult: `report/candidate/examreportpdf`,
  examGroupList: `admin/examgroup/list`,
  examGroupCreate: `admin/create/examgroup`,
  getAssignedQuestion: `admin/exam/assign_questions`,
  getAssignedQuestionSet: `admin/set/questions`,
  getAdminSetQuestions:`admin/set/questions`,
  getQuestionSetConfigForExam: `admin/sets`,
  getExamQuestionSetStat: `admin/setconfig/byexamid`,
  getExamConfigByExamId: `admin/examconfig/byexamid`,
  getAllexaminee: `admin/user/alluser`,
  examViewPDF: `report/candidate/examreportpdf`,
  editQuestionURL: `admin/question/edit`,
  addDomainURL: `common/add/config`,
  generatePDF: `report/result/generate_pdf/`,
  getExamineeViewDetails: `admin/examineedetails/byexamgroupid`,
  generateAdmitCard: `report/admit/generate_pdf`,
  downloadAdmitCard: `report/candidate/admitcardpdf`,
  pendingRequestURL: `center/pendingRequestList`,
  updateResumeRequest: `center/updateResumeReq`,
  requestResumeRequest: `center/requestResume`,
  getExamDetailsForCentreAdmin: `server_comunication_local/get-exam-slot`,
  testCentreAdminGetExamInfo: `server_comunication_local/execute-dump-decoded-sql`,
  finalExamCompleteByTestCenter: `center/testcenter/finalExamComplete`,
  getDashboardDetails: `monitoring_unit/dashboard`,
  getQuestionMarksInAssignedQuestions: `/monitoring_unit/get-ques-comp-marks`,
  getExamMonitoringDetails: `monitoring_unit/get-slot-details`,
  monitoringUnitSlotCenterDetails: `admin/monitoring/unit/slotcenterdetails`,
  getAllCustomerList: `admin/get-customers-list`,
  createCustomerAdmin: `admin/customer/create`,
  createCustomerAdminCenter: `center/admin/createcenter`,
  cancelExamList:`admin/cancel_exam_paper/list`,
  candidateCreationOrOperation: `user/opration `,
  examCreationStatus: `admin/exam-creation-status`,
  centerList: `center/list`,
  approveScrutiny: `scrutiny/approval`,
  scrutinyListing: `scrutiny/scrutiny_listing`,
  createCenterURL: `center/admin/createcenter`,
  getOverallCandidateList: `user/list`,
  centerAlottmentUrl: `admin/org/exam/user/center/mapping`,
  getCenterAlttmentUrl: `admin/userlistbyexamid`,
  getOrgDetailsById: `center/orgdetails`,
  uploadCandidateByExcel: `user/opration/excel`,
  knowMyCreditBalance: `admin/credit/manage`,
  getCalculationListOfCredit: `admin/credit/calulation`,
  thumbnailList: `common/thumbnails`,
  updatePassword: `admin/updatepassword`,
  loginUserTypesByEmail: `users/orgdetailsbyemail`,
  contactUs: `admin/contact_us`,
  contactUsList: `admin/contact_us/list`,
  getCreditPointAuditTrails: `admin/credit_trail/list`,
  getProctoringList: `admin/proctoring_list`,
  cancelExamPaperURL: `admin/cancel_exam_paper`,
  userDetailsURL:`user/details`,
  centerUpdateTime:`center/updateTime`,
  domainExtraData:`common/domain/`,
  slotDetailsByID:`admin/slotdetailsbyid`,
  questionTemplateDownload:`admin/question/download`
};

export const sidebarDetails: Array<any> = [
  {
    sideBarurl: CustomerManage,
    forCentralAdmin: true,
    sidebarText: "Customer Management",
    navURL: [
      `/admin/exams/customer-management`,
      `/admin/exams/customer-management/create-customer`,
    ],
    nestedMenu: [],
  },
  {
    sideBarurl: ExamManangement,
    sidebarText: "Exam Management",
    navURL: [
      `/admin/exams/view-exams`,
      `/admin/exams/view-exam-group`,
      `/admin/exams/create-exams-group`,
      `/admin/exams/assign-question-exam-paper`,
      `/admin/exams/question-set-configure`,
      `/admin/exams/specific-center-users`,
      `/admin/exams/edit-exam`,
      `/admin/exams/candidate-allotment-setup`,
      `/admin/candidate/candidate-management/details`,
    ],
    nestedMenu: [
      {
        sideBarurl: viewExams,
        sidebarText: "Exams",
        navURL: `/admin/exams/view-exams`,
        adjacentLink: [
          `/admin/exams/create-exams`,
          `/admin/exams/view-exam-group`,
          `/admin/exams/view-exams`,
          `/admin/exams/create-exams-group`,
        ],
      },
      {
        sideBarurl: viewExams,
        sidebarText: "Exam Papers",
        navURL: `/admin/exams/exam-paper`,
        adjacentLink: [
          `/admin/exams/create-exams`,
          `/admin/exams/assign-question-exam-paper`,
          `/admin/exams/question-set-configure`,
          `/admin/exams/edit-exam`,
        ],
      },

      {
        sideBarurl: viewRes,
        sidebarText: "Candidate Allotment",
        navURL: `/admin/exams/candidate-allotment`,
        adjacentLink: [
          `/admin/exams/specific-center-users`,
          `/admin/exams/candidate-allotment-setup`,
          `/admin/candidate/onboard-candidate`,
        ],
      },
      {
        sideBarurl: viewRes,
        sidebarText: "Exam Candidate List  ",
        navURL: `/admin/candidate/exam-candidate-list`,
        adjacentLink: [`/admin/candidate/candidate-management/details`],
      },
    ],
  },
  {
    sideBarurl: examCentre,
    sidebarText: "Center Management",
    navURL: [
      `/admin/exams-center/center-registry`,
      `/admin/exams-center/create-center`,
      `/admin/exams-center/specific-center-users`,
      `/admin/exams-center/candidate-allotment`,
    ],
    nestedMenu: [
      {
        sideBarurl: genResult,
        sidebarText: "Center Registry",
        navURL: `/admin/exams-center/center-registry`,
        adjacentLink: [
          `/admin/exams-center/create-center`,
          `/admin/exams-center/candidate-allotment`,
        ],
      },
      {
        sideBarurl: slot_exam,
        sidebarText: "Exam Slot",
        navURL: `/admin/exams/slot-allotment`,
        adjacentLink: [`/admin/exams/create-exams`],
      },
    ],
  },
  {
    sideBarurl: questionManagementImg,
    sidebarText: "Question Management",
    forOnlyAdmin: true,
    navURL: [`/admin/question/question-bank`],
    adjacentLink: [
      `/admin/question/create-question`,
      `/admin/exams/exam-set-configuration`,
    ],
    nestedMenu: [
      {
        sideBarurl: slot_exam,
        sidebarText: "Question Registry",
        navURL: `/admin/question/question-bank`,
        adjacentLink: [`/admin/exams/create-exams`],
      },
      {
        sideBarurl: viewExams,
        sidebarText: "Question Set",
        navURL: `/admin/exams/exam-set-configuration`,
        adjacentLink: [],
        forAdmin: true,
      },
    ],
  },
  {
    sideBarurl: examinee,
    sidebarText: "Candidate Management",
    navURL: [
      `/admin/candidate/candidate-management`,

      `/admin/candidate/create-candidate`,
      `/admin/exams-center/exams-candidate`,
      `/admin/candidate/onboard-candidate`,
    ],
    adjacentLink: [
      `/admin/candidate/create-candidate`,
      `/admin/exams-center/exams-candidate`,
      `/admin/candidate/onboard-candidate`,
    ],
    nestedMenu: [
      {
        sideBarurl: genResult,
        sidebarText: "Candidate Registry",
        navURL: `/admin/candidate/candidate-registry`,
        adjacentLink: [
          `/admin/candidate/create-candidate`,
          `/admin/exams-center/exams-candidate`,
          `/admin/candidate/onboard-candidate`,
        ],
      },
    ],
  },
  {
    sideBarurl: resulttest,
    sidebarText: "Result Management",
    navURL: [`/admin/result/registry`],
    nestedMenu: [
      {
        sideBarurl: genResult,
        sidebarText: "Generate & Publish",
        navURL: `/admin/result/generate-result`,
      },
      {
        sideBarurl: viewRes,
        sidebarText: "View",
        navURL: `/admin/result/registry`,
      },
    ],
  },

  {
    sideBarurl: pendingRequest,
    sidebarText: "Pending Request",
    navURL: [`/admin/exams/pending-request`],
    nestedMenu: [],
  },
  {
    sideBarurl: pendingRequest,
    sidebarText: "Session Management",
    navURL: [`/admin/exams/session-management`],
    nestedMenu: [],
  },
  {
    sideBarurl: examSession,
    sidebarText: "Objection Management",
    navURL: [`/admin/exams/objection-management`],
    nestedMenu: [],
  },
  {
    sideBarurl: examSession,
    sidebarText: "Monitoring Dashboard",
    navURL: [`/admin/exams/monitoring-dashboard`],
    nestedMenu: [],
  },
  {
    sideBarurl: mastermenumain,
    sidebarText: "Contact Us Registry",
    navURL: [`/admin/exams/contactus`],
    nestedMenu: [],
    forCentralAdmin: true,
  },
  {
    sideBarurl: mastermenumain,
    sidebarText: "Audit Trails",
    navURL: [`/admin/exams/audit-trails`],
    nestedMenu: [],
  },
  {
    sideBarurl: mastermenumain,
    sidebarText: "Domain Management",
    navURL: [`/admin/exams/domain-management`],
    nestedMenu: [],
    forCentralAdmin: true,
  },
];

export const DomainTypesList = [
  {
    key: "subject",
    label: "Subjects",
  },
  {
    key: "marks",
    label: "Marks",
  },
  {
    key: "complexity",
    label: "Complexity",
  },
  {
    key: "language",
    label: "Language",
  },
];

export const DomainTypeColumnList = [
  {
    domainKey: "subject",
    columns: [
      {
        key: "domain_key",
        title: "Subject Key",
        width: 200,
        dataType: DataType.String,
        // field: "domain_key",
        // headerName: "Subject Key",

        // flex: 1,
        // headerAlign: "center"
      },
      {
        // field: "domain_value",
        // headerName: "Subject Name",
        // flex: 1,
        key: "domain_value",
        title: "Subject Name",
        width: 200,
        dataType: DataType.String,
        // headerAlign: "center"
      },
    ],
  },
  {
    domainKey: "marks",
    columns: [
      {
        // field: "domain_key",
        // headerName: "Marks Key",

        // // headerAlign: "center",
        // flex: 1,
        key: "domain_key",
        title: "Marks Key",
        width: 200,
        dataType: DataType.String,
      },
      {
        key: "domain_value",
        title: "Marks",
        width: 200,
        dataType: DataType.Number,
        // field: "domain_value",
        // headerName: "Marks",
        // flex: 1,

        // headerAlign: "center"
      },
    ],
  },
  {
    domainKey: "complexity",
    columns: [
      {
        key: "domain_key",
        title: "Complexity Key",
        width: 200,
        dataType: DataType.String,
        // field: "domain_key",
        // headerName: "Complexity Key",

        // // headerAlign: "center",
        // flex: 1
      },
      {
        key: "domain_value",
        title: "Complexity Name",
        width: 200,
        dataType: DataType.String,
        // field: "domain_value",
        // headerName: "Complexity Name",
        // width: 200,

        // headerAlign: "center",
      },
    ],
  },
  {
    domainKey: "language",
    columns: [
      {
        key: "domain_key",
        title: "Language Key",
        width: 200,
        dataType: DataType.String,
        // field: "domain_key",
        // headerName: "Language Key",

        // // headerAlign: "center",
        // flex: 1
      },
      {
        key: "domain_value",
        title: "Language Name",
        width: 200,
        dataType: DataType.String,
        // field: "domain_value",
        // headerName: "Language Name",
        // width: 200,

        // headerAlign: "center",
      },
    ],
  },
];

export enum DomainEnum {
  LANGUAGE = "language",
  COMPLEXITY = "complexity",
  MARKS = "marks",
  SUBJECT = "subject",
}

export enum ComplexityTypeEnum {
  Complex = "Complex",
  Medium = "Medium",
  Simple = "Simple",
}

export enum CreateExamEnum {
  CREATEEXAM = 0,
  ASSIGN_QUESTION = 1,
  CONFIGURE_QUESTION_SET = 2,
}

export const errorMessageTextForQuestion =
  "Question bank does not have enough questions as per the configuration";

export const ALPHABETS = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];

export const allowedExtensions = ["xls", "xlsx"];
export enum EUserType {
  LOCALSERVERADMIN = "TCADMIN",
  CENTRALADMIN = "ADMIN",
  CUSTMONADMIN = "CUSTMONADMIN",
  USER = "USER",
  CUSTADMIN = "CUSTADMIN",
  MONADMIN = "MONADMIN",
}

export enum ExamStepEnum {
  ExamInfo = "EXAMINFO",
  DownloadQuestion = "DOWNLOADQUESTION",
  DecryptQuestion = "DECRYPTQUESTION",
  UPLOADANSWERS = "UPLOADANSWERS",
}

export const showExamStatus = [
  "/admin-dashboard/generate-result",
  "/admin-dashboard/result",
  "/admin-dashboard/pending-request",
  "/admin-dashboard/exam-session",
  "/admin-dashboard/domain-management",
  "/admin-dashboard/create-question",
  "/admin-dashboard/question-bank",
];

export enum GetCentreExamInfo {
  GETEXAMINFO = 2,
  DOWNLOADQUESTIONS = 3,
  UNLOCKQUESTIONS = 4,
  UPLOADANSWERS = 5,
}

export const DEFAULT_BATCH_SIZE = 100;

export enum MonitoringDashboardExamStatus {
  EXAMINATION_NOT_INIT = "",
  EXAMINATION_CENTRE_SETUP_COMPLETED = "EXAMINATION_CENTRE_SETUP_COMPLETED",
  EXAM_INFORMATION_DOWNLOAD = "EXAM_INFORMATION_DOWNLOAD",
  QUESTION_DOWNLOADED = "QUESTION_DOWNLOADED",
  QUESTION_UNLOCKED = "QUESTION_UNLOCKED",
  EXAM_IN_PROGRESS = "EXAM_IN_PROGRESS",
  EXAM_PAUSED = "EXAM_PAUSED",
  EXAM_POSTPOND = "EXAM_POSTPOND",
  EXAM_CANCELLED = "EXAM_CANCELLED",
  EXAM_NOT_STARTED = "EXAM_NOT_STARTED",
  EXAM_RESUMED = "EXAM_RESUMED",
  EXAM_COMPLETED = "EXAM_COMPLETED",
  ANSWER_SUBMITTED = "ANSWER_SUBMITTED",
  ANSWER_NOT_SUBMITTED = "ANSWER_NOT_SUBMITTED",
  RESULT_PUBLISHED = "RESULT PUBLISHED",
}

// export const ISTESTCENTREADMINPANEL: EUserType = EUserType.CENTRALADMIN;
export const ISTESTCENTREADMINPANEL: "ONLINE" | "OFFLINE" = "ONLINE";
export const notShowStepPathnames = [
  // "/admin-dashboard/view-exams",
  "/admin-dashboard/question-bank",
  "/admin-dashboard/create-question",
  "/admin-dashboard/monitoring-dashboard",
  "/admin-dashboard/customer-management",
  "/admin-dashboard/result",
  "/admin-dashboard/generate-result",
  "/admin-dashboard/objection-management",
];

export const showGlobalExamOrCustomerModalForSuperAdminLocations = [
  "/admin/exams/exam-set-configuration",
  "/admin/exams/exam-paper",
  "/admin/exams/center-allotment",
  "/admin/exams/slot-allotment",
  "/admin/result/generate-result",
  "/admin/candidate/exam-candidate-list",
  "/admin/result/registry",
  "/admin/exams/session-management",
  "/admin-dashboard/pending-request",
  "/admin/exams/monitoring-dashboard",
  "/admin/exams/session-management",
  "/admin/exams/objection-management",
  "/admin/exams-center/candidate-assignment",
  "/admin/exams-center/center-registry",
  "/admin/exams-center/center-allotment",
  "/admin/question/question-bank",
  "/admin/candidate/candidate-registry",
  "/admin/exams/pending-request",
];

export const showGlobalExamOrCustomerModalForCustomerAdminLocations: Array<string> =
  [
    "/admin/exams/exam-set-configuration",
    "/admin/exams/exam-paper",
    "/admin/exams/center-allotment",
    "/admin/exams/slot-allotment",
    "/admin/result/generate-result",
    "/admin/candidate/exam-candidate-list",
    "/admin/result/registry",
    "/admin/exams/session-management",
    "/admin-dashboard/pending-request",
    "/admin/exams/monitoring-dashboard",
    "/admin/exams/session-management",
    "/admin/exams/objection-management",
    "/admin/exams-center/candidate-assignment",
    "/admin/exams-center/center-allotment",
    "/admin/exams/pending-request",
    "/admin/exams/candidate-allotment",
  ];

export enum EXAM_MODE_ENUM {
  ONLINE = 1,
  OFFLINE = 2,
  HYBRID = 3,
}

export const suggestiveCreditPoint = [5, 10, 50, 100, 200, 350, 500];
